import plusRound from '~/assets/icons/plus_round.svg';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections/CurrencyIcon';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage } from '~/rage';
import { Currency } from '~/shared';
import { StyledContainer, StyledPrice } from './CharacterCreate.styled';

const CharacterCreate = ({
	index,
	price,
}: {
	index: number;
	price?: number;
}) => {
	const donateIcon = useWalletIcon(Currency.Donate, true);

	return (
		<StyledContainer
			data-character-select-card
			onMouseEnter={() => playSound(Sound.LinkCursor)}
			onClick={() => {
				rage.characterSelection.createCharacter(index);
				playSound(Sound.ClickButton);
			}}
		>
			<img src={plusRound} className="icon" />
			<Text style={{ fontWeight: 500, fontSize: 16 }}>Создать персонажа</Text>
			{price ? (
				<StyledPrice>
					<Text>{price.toLocaleString('ru-RU')}</Text>
					<CurrencyIcon icon={donateIcon} size="lg" />
				</StyledPrice>
			) : (
				<Text style={{ fontWeight: 500, fontSize: 16, opacity: 0.5 }}>
					Бесплатно
				</Text>
			)}
		</StyledContainer>
	);
};

export { CharacterCreate };
